import { z } from "zod";
export const testConnectionResponseSchema = z.object({
    success: z.boolean(),
    error: z.string().nullable().optional(),
});
